 /* Custom Script to Show "Subscribe to back in stock" form from Klaviyo */
    // Ids
    const KLAVIYO_FORM_ID = 'Y4HBwH';
    const formWrapperId = 'sold-out-form-custom-v2';

    // Selectors
    const parentSelector = '.shopify-section.shopify-section--main-product .product-info__block-list';
    const sibilingSelector = '.product-info__block-item[data-block-type="buy-buttons"]';
    const buttonSelector = '.shopify-section.shopify-section--main-product .product-info__block-item[data-block-type="buy-buttons"] buy-buttons.buy-buttons button.button';

    // Functions
    function hideForm () {
      document.querySelector('#'+formWrapperId).style.display = 'none';
    }

    function showForm () {
      document.querySelector('#'+formWrapperId).style.display = 'block';
    }

    function addForm () {
      const parentElement = document.querySelector(parentSelector);
      const targetElement = parentElement.querySelector(sibilingSelector);
      if (parentElement && targetElement) {
        const newElement = document.createElement('div');
        newElement.id = formWrapperId;
        newElement.className = 'product-info__block-item';
        newElement.style.display = 'none';
        newElement.innerHTML = `<div class="klaviyo-form-${KLAVIYO_FORM_ID}"></div>`;
        newElement.setAttribute('data-block-type', 'sold-out-form');
        targetElement.insertAdjacentElement('afterend', newElement);
      }
    }

    function handleSoldOutForm () {
      const buttonElement = document.querySelector(buttonSelector);
      addForm();
      if (buttonElement?.disabled) showForm();
      
      // Change state
      const handleButtonChange = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            buttonElement?.disabled ? showForm() : hideForm();
          }
        }
      };
      const config = { attributes: false, childList: true, subtree: true };
      const observer = new MutationObserver(handleButtonChange);
      observer.observe(buttonElement, config); 
    }



document.addEventListener("DOMContentLoaded", function() {
  const soldOutFormInterval = setInterval(() => {
    const button = document.querySelector(buttonSelector);
    if (button) {
      handleSoldOutForm();
      clearInterval(soldOutFormInterval);
    }
  }, 200)
});
